import {FC, useState} from "react";
import {Button, Upload, UploadFile, Image, Form, App} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import {getBase64FromUpload, UploadFileType} from "../../utils/getBase64FromUpload.ts";
import {normalizeFile} from "../../utils/normalizeFile.ts";
import {addGridToBase64Image} from "../../utils/addGridToBase64Image.ts";

type Props = {
    name: string;
    required?: boolean;
}

export const BannerUpload: FC<Props> = ({ name, required }) => {
    const { message } = App.useApp();
    const [previewImage, setPreviewImage] = useState<string>();

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64FromUpload(file.originFileObj as UploadFileType);
        }

        setPreviewImage(await addGridToBase64Image(file.url || (file.preview as string)));
    };

    return (
        <>
            <Form.Item
                noStyle={!required}
                name={name}
                valuePropName="fileList"
                getValueFromEvent={(f) => {
                    try { return normalizeFile(f) }
                    catch(e) { void message.error(e instanceof Error ? e.message : String(e)); }
                }}
                rules={required ? [{ required: true, message: 'Загрузите баннер' }] : undefined}
            >
               <Upload
                   accept="image/*"
                   listType="picture"
                   beforeUpload={() => false}
                   maxCount={1}
                   onPreview={handlePreview}
               >
                   <Button icon={<UploadOutlined />}>Загрузить</Button>
               </Upload>
            </Form.Item>
            {previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: Boolean(previewImage),
                        onVisibleChange: () => setPreviewImage(undefined),
                    }}
                    src={previewImage}
                />
            )}
        </>
    )
}